import { type ComponentType, type ReactNode, Suspense, lazy } from 'react'

interface DynamicOptions {
  loading?: ComponentType
  ssr?: boolean
}

export default function dynamic(
  // biome-ignore lint/suspicious/noExplicitAny: mirrors the generic next/dynamic adapter boundary.
  loader: () => Promise<{ default: ComponentType<any> }>,
  options: DynamicOptions = {}
  // biome-ignore lint/suspicious/noExplicitAny: mirrors the generic next/dynamic adapter boundary.
): ComponentType<any> {
  const LazyComponent = lazy(loader)
  const LoadingComponent = options.loading

  // biome-ignore lint/suspicious/noExplicitAny: mirrors the generic next/dynamic adapter boundary.
  return function ViteDynamicComponent(props: any): ReactNode {
    return (
      <Suspense fallback={LoadingComponent ? <LoadingComponent /> : null}>
        <LazyComponent {...props} />
      </Suspense>
    )
  }
}
